import React, { useContext, useEffect, useState } from 'react'
import Sidebar from '../components/Sidebar'
import { AppContexte } from '../contexts/context'
import { getAuthToken } from '../api/auth'
import { Navigate } from 'react-router-dom'
import { accountLink } from '../constants/endspoints'
import { useQuery } from '@tanstack/react-query'
import { fetchUserById } from '../api/user'

const AdminLayout = ({children}) => {

    const { section, decodedToken } = useContext(AppContexte)

    const [dat,setDate] = useState(new Date())
    useEffect(()=>{
        setInterval(
            ()=>setDate(new Date())
            ,1000
        )
    })

    const token = getAuthToken();
    useEffect(() => {
        if (!token) {
            return <Navigate to={accountLink} />;
        }
    }, [token]);


    // Fetch single user by ID
    const { data: user, isLoading: isFetchingUser } = useQuery({
        queryKey: ['user', decodedToken?.id],
        queryFn: () => fetchUserById(decodedToken?.id),
        enabled: !!decodedToken?.id,
    });



    return (
        <div className='position-relative d-flex flex-row m-0 p-0 justify-content-start'>
            <div className='position-relative d-flex flex-row m-0 p-0'>
                <Sidebar/>
            </div>
            <div className='main'>

            <div className='main-head bgcolor-primary px-3 py-2'>
                <button className="btn border-0 d-md-none p-0" data-bs-toggle="offcanvas" data-bs-target="#submenu">
                    <i className="fa-light fa-bars"></i>
                </button>
                <div>
                {
                    isFetchingUser?
                    <div className='placeholder-wave' style={{width: "15rem"}}>
                        <p className='bg-white placeholder col-6 fs-9s mb-0 '></p>
                    </div>
                    :
                    <div className='d-flex flex-wrap flex-column lh-sm'>
                        <p className='text-capitalize text-white fs-9s mb-0'>{user? user?.data?.name : section}</p>
                        <p className='text-capitalize text-white fs-7s mb-0'>{user? user?.data?.job : null}</p>
                    </div>
                }
                </div>
                <div className='d-flex align-items-center'>
                <p className='d-md-block d-none fs-9s text-white m-0 '>{dat.toLocaleTimeString()}</p>
                    {/* <SearchBar/> */}
                </div>
            </div>

            <div className='main-body px-2 px-md-3 py-md-4 py-3'>


                {children}


            </div>

            </div>
        </div>
    )
}

export default AdminLayout